//Author June Leow
//Date Mar 22nd, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import React, {useReducer, useEffect} from 'react';
import {Card, CardHeader, CardBody, Col, Row, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import CondoCarStorages from './condo-car-storages';
import ExteriorDeficiencies from './exterior-deficiencies';
import ExteriorUpdates from './exterior-updates';
import Units from './units';
import MySelect from '../../../util/my-select';
import {NavLink} from 'react-router-dom';


const structureTypeEnum = [
  {value:'DWELLING', label:'Dwelling'}, 
  {value:'WORKSHOP', label:'Workshop'}, 
  {value:'BARN', label:'Barn'}, 
  {value:'POLE_BUILDING', label:'Pole Building'}, 
  {value:'STABLES', label:'Stables'}, 
  {value:'RIDING_ARENA', label:'Riding Area'}, 
  {value:'POOL_HOUSE', label:'Pool House'}, 
  {value:'DETACHED_GARAGE', label:'Detached Garage'}, 
  {value:'OTHER_OUTBUILDING', label:'Other Outbuilding'}, 
];

const attachmentTypeEnum = [
  {value:'ATTACHED', label:'Attached'}, 
  {value:'DETACHED', label:'Detached'}, 
  {value:'LEFT_SEMI_DETACHED', label:'Left Semi Detached'}, 
  {value:'RIGHT_SEMI_DETACHED', label:'Right Semi Detached'}, 
];

const foundationTypeEnum = [
  {value:'SLAB', label:'Slab'}, 
  {value:'CRAWLSPACE', label:'Crawlspace'}, 
  {value:'BASEMENT', label:'Basement'}, 
  {value:'POST_PIER', label:'Post Pier'}, 
  {value:'RUNNER', label:'Runner'}, 
];

const constructionTypeEnum = [
  {value:'FRAME', label:'Frame'}, 
  {value:'MASONRY', label:'Masonry'}, 
  {value:'LOG', label:'Log'}, 
  {value:'MANUFACTURED', label:'Manufactured'}, 
  {value:'MODULAR', label:'Modular'}, 
  {value:'GEODESIC', label:'Geodesic'}, 
  {value:'EARTH_BERM', label:'Earth Berm'}, 
  {value:'3D_PRINTED', label:'3D Printed'}, 
];

const constructionStatusEnum = [
  {value:'COMPLETE', label:'Complete'}, 
  {value:'INCOMPLETE_CONSTRUCTION', label:'Incomplete Construction'}, 
  {value:'INCOMPLETE_RENOVATION_CONSTRUCTION', label:'Incomplete Renovation Construction'}, 
  {value:'PROPOSED', label:'Proposed'}, 
];

const buildingDesignEnum = [
  {value:'GARDEN', label:'Garden'}, 
  {value:'LOW_RISE', label:'Low Rise'}, 
  {value:'MID_RISE', label:'Mid Rise'}, 
  {value:'HIGH_RISE', label:'High Rise'}, 
  {value:'ROWHOUSE_TOWNHOUSE', label:'Rowhouse Townhouse'}, 
  {value:'DETACHED', label:'Detached'}, 
  {value:'OTHER', label:'Other'}, 
];

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//initialize the state
const initialState = {

};

//reducer function that perform state update
const reducer = getReducer();


const Building  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const numberOnly= (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
  };

  const getFoundationTypeLabel = (value)=>{
    for(let i=0;i<foundationTypeEnum.length;i++){
      if(foundationTypeEnum[i].value===value)
        return foundationTypeEnum[i].label;
    }
    return value;
  }

  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const handleYearChange = (event, index) => {
    let value = event.target.value;

    // Remove non-numeric characters
    value = value.replace(/\D/g, '');

    const currentYear = new Date().getFullYear();

    // Ensure it's at most 4 digits
    if (value.length > 4) value = value.slice(0, 4);

    // Ensure the year is within the valid range (1000 - currentYear)
    if (value.length==4 && value && (parseInt(value) < 1000 || parseInt(value) > currentYear)) {
        value = currentYear.toString(); // Default to the current year if out of range
    }

    event.target.value = value; // Enforce the valid year

    updateBuildingDetail(index,'yearBuilt', value)
};

  const handleYearKeyDown = (event) => {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    // Allow digits and control keys, prevent anything else
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
        event.preventDefault();
    }
};

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let buildings = newUPD.property.buildings.slice()
   
                let target = buildings[index][field]?buildings[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:buildings[index].ID, description:description});
                buildings[index][field] = target;
                newUPD.property.buildings = buildings;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice()
    let target = buildings[index][field]?buildings[index][field]:null;

    if(target &&  target[index2]){
      target[index2].description = description;
    }
    console.log(target);
    console.log(buildings)

    newUPD.property.buildings = buildings;
    props.update(newUPD);
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice()
    let target = buildings[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        buildings[index][field] = target;
        newUPD.property.buildings = buildings;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      buildings[index][field] = target;
      newUPD.property.buildings = buildings;
      props.update(newUPD);
    }
  }

  const addBuilding = ()=>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice();
    buildings.push({imageStructureFront:[], imageStructureRear:[], imageStructureLeft:[], imageStructureRight:[],imageBuildingFront:[], imageBuildingRear:[], imageBuildingLeft:[], imageBuildingRight:[],imageDwellingFront:[], imageDwellingRear:[], imageDwellingLeft:[], imageDwellingRight:[], condoCarStorages:[],exteriorDeficiencies:[],exteriorUpdates:[], units:[{imageFloorPlan:[], unitView:{views:[]}, featureTypes:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], belowGradeExits:[], atticAccess:[], rooms:[{roomType:'', imageRoom:[], imageLivingroom:[], imageKitchen:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}]});

    newUPD.property.buildings = buildings;
    props.update(newUPD);
  }

  const removeBuilding = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice();
    buildings.splice(index, 1);
    newUPD.property.buildings = buildings;
    props.update(newUPD);
  }

  const updateBuildingDetail = (index, field, value) =>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice();
    buildings[index][field] = value;

    if(field==='condoOffstreetParkingAvailable'){
      if(value==='True'){
        buildings[index].condoCarStorages = [{imageOutsideGarage:[], imageInsideGarage:[], imageCarport:[], imageOpenAssigned:[]}];
      }
      else{
        buildings[index].condoCarStorages = [];
      }
    }

    newUPD.property.buildings = buildings;
    props.update(newUPD);
  }

  const updateBuildingFoundation = (index, value) =>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice();
    let foundationType = buildings[index].foundationType?buildings[index].foundationType.slice():[];
    let found = false;

    for(let i=0;i<foundationType.length;i++){
      if(foundationType[i]===value){
        found = true;
        break;
      }
    }
    if(!found)
      foundationType.push(value);
    newUPD.property.buildings[index].foundationType = foundationType;
    props.update(newUPD);
  }

  const removeBuildingFoundation = (index, index2) =>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice();
    let foundationType = buildings[index].foundationType?buildings[index].foundationType.slice():[];
    foundationType.splice(index2, 1);
    newUPD.property.buildings[index].foundationType = foundationType;
    props.update(newUPD);
  }
  

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  
 
  
  return (
    <div>
      <br/>
      <Row>
        <Col sm="10">
          <div className="red-color" style={{fontSize:'13px'}}>
            <i className="fa fa-check green-color"/> Add all buildings (house, garage, barn, ADU, shed) &nbsp;&nbsp;
            <i className="fa fa-check green-color"/> Provide a floor plan for each structure &nbsp;&nbsp;
            <i className="fa fa-check green-color"/> Ensure structure details match the floor plan&nbsp;&nbsp;
            <i className="fa fa-times red-color"/> Do NOT enter buildings as property improvements 
          </div>
        </Col>
        <Col sm="2">
          {props.disabled?null:<div className="align-right">
            <NavLink to="#" onClick={(e)=>addBuilding()}><i className="fa fa-plus green-color"/> Add Building&nbsp;&nbsp;&nbsp;&nbsp;</NavLink>
          </div>}
        </Col>
      </Row>
      {
        props.upd.property.buildings.map(
          (building, index)=>{
            let offstreetParking;

            if(building.buildingDesign==='GARDEN'||building.buildingDesign==='LOW_RISE'||building.buildingDesign==='MID_RISE'||building.buildingDesign==='HIGH_RISE'){
              offstreetParking = <Row>
                <Col sm="5">
                <label>{!props.disabled ?<font color="red">*</font>:null}Indicate whether the  building has parking or car storage available.</label>
                <MySelect
                  type="select"
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  required={!props.disabled}
                  value={building.condoOffstreetParkingAvailable}
                  onChange={(v)=>updateBuildingDetail(index, 'condoOffstreetParkingAvailable', v)}
                  options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                />
                </Col>
              </Row>
            }
            
            let constructionType;

            if(props.upd.property.propertyType==='SF'){
              constructionType = <Col sm="6">
              <label>{props.upd.property.propertyType==='SF'?<font color="red">*</font>:null}Select the option that best describes the construction type. {generateTooltip('constructionType'+index, 'Indicate the construction type that best describes the construction of the majority of the structure.')}</label>
              <MySelect
                type="select"
                required={!props.disabled&& props.upd.property.propertyType==='SF'}
                disabled={props.disabled}
                style={props.disabled?disabledStyling:{}}
                value={building.constructionType}
                onChange={(v)=>updateBuildingDetail(index, 'constructionType', v)}
                options={constructionTypeEnum}
              />
            </Col>;
            }
            let projectNameBuildingNumber = <Row>
            <Col sm="6">
              <label>The name of the condo project, the unit is a part of.</label>
              <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={building.projectName} onChange={(e)=>updateBuildingDetail(index,'projectName', e.target.value)}/>
            </Col>
            <Col sm="6">
              <label>The building number that the unit is in.</label>
              <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={building.buildingNumber} onChange={(e)=>updateBuildingDetail(index,'buildingNumber', e.target.value)}/>
            </Col>
          </Row>;
          
            return (<div key={index} id={`building-${index}`}>
              <br/>
              <Card>
                <CardHeader className="header-color">{index!==0?<i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeBuilding(index)}/>:null} Building #{index+1}</CardHeader>
                <CardBody>
                  {props.upd.property.propertyType==='SF'?<div>
                    <Row>
                      <Col sm="12">
                        <label>{!props.disabled?<font color="red">*</font>:null}Select the option that best identifies the type of structure.  {generateTooltip('structureType'+index, 'Select the best option to classify all permanently affixed structures. All structures should be identified.  Any structure with finished area should include the necessary data to describe the finished space within the structure.  Dwelling should be selected for only structures that are predominantly living.')}</label>
                        <MySelect
                          type="select"
                          required={!props.disabled}
                          disabled={props.disabled}
                          style={props.disabled?disabledStyling:{}}
                          value={building.structureType}
                          onChange={(v)=>updateBuildingDetail(index, 'structureType', v)}
                          options={structureTypeEnum}
                        />
                      </Col>
                      <Col sm="12">
                        <label>{!props.disabled?<font color="red">*</font>:null}Provide the total area for each structure selected (In Sqft). {generateTooltip('structureArea'+index, 'Provide the structure\'s total area including finished and unfinished areas. Can be derived mathematically. ')}</label>
                        <div className="red-color" style={{fontSize:'13px'}}>
                          <i className="fa fa-check green-color"/> Include all structures (main house, attached garage, attached spaces) <br/>
                          <i className="fa fa-check green-color"/> Include attached garage in structure area <br/>
                          <i className="fa fa-check green-color"/> Must match floor plan totals<br/>
                          <i className="fa fa-times red-color"/> Do NOT include porch, detached garage or non-structural areas <br/>
                        </div>
                        <Input pattern="[0-9]*" onKeyDown={numberOnly} style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={building.structureArea} onChange={(e)=>updateBuildingDetail(index,'structureArea', e.target.value)}/>
                      </Col>
                    </Row>
                    <br/>
                  </div>:null}
                  {props.upd.property.propertyType==='CONDO'?<div>
                    <Row>
                      <Col sm="6">
                        <label>{!props.disabled && props.upd.property.propertyType==='CONDO'?<font color="red">*</font>:null}Identify the design style for the building in which the unit is located. {generateTooltip('buildingDesign'+index, 'Identify the design style for the building in which the unit is located. If none of the building designs listed apply, select "Other".')}</label>
                        <MySelect
                          type="select"
                          required={!props.disabled && props.upd.property.propertyType==='CONDO'}
                          disabled={props.disabled}
                          style={props.disabled?disabledStyling:{}}
                          value={building.buildingDesign}
                          onChange={(v)=>updateBuildingDetail(index, 'buildingDesign', v)}
                          options={buildingDesignEnum}
                        />
                      </Col>
                      <Col sm="6">
                        <label>{!props.disabled && building.buildingDesign==='OTHER'?<font color="red">*</font>:null}Please describe the building design</label>
                        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled && building.buildingDesign==='Other'} type="text" value={building.buildingDesignDescription} onChange={(e)=>updateBuildingDetail(index,'buildingDesignDescription', e.target.value)}/>
                      </Col>
                    </Row>
                    <br/>
                    {projectNameBuildingNumber}
                  </div>:null}
                  <Row>
                    <Col sm="3">
                      <label>{!props.disabled?<font color="red">*</font>:null}Does this structure contain any rooms?</label>
                      <MySelect
                        type="select"
                        required={!props.disabled}
                        disabled={props.disabled}
                        style={props.disabled?disabledStyling:{}}
                        value={building.containsRooms}
                        onChange={(v)=>updateBuildingDetail(index, 'containsRooms', v)}
                        options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                      />
                    </Col>
                    <Col sm="4">
                      <label>{!props.disabled && ((props.upd.property.propertyType==='SF' && building.structureType==="DWELLING") || props.upd.property.propertyType==='CONDO')?<font color="red">*</font>:null}What year was the structure originally constructed? {generateTooltip('yearBuilt'+index,'Best practice is to furnish the year built of each structure from a reliable data source, as available. The Property Data Collector should confirm the provided year built with the property POC. The application should allow the user to enter the year built if it is either unavailable or incorrect, according to the POC.')} </label>
                      <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled && ((props.upd.property.propertyType==='SF' && building.structureType==="DWELLING") || props.upd.property.propertyType==='CONDO')} pattern="[0-9]*" onKeyDown={handleYearKeyDown} type="text" value={building.yearBuilt} onChange={(e)=>handleYearChange(e, index)}/>
                    </Col>
                    <Col sm="5">
                      <label>{!props.disabled && ((props.upd.property.propertyType==='SF' && building.structureType==="DWELLING") || props.upd.property.propertyType==='CONDO')?<font color="red">*</font>:null}Is the year provided for when the structure was originally constructed an estimate?</label>
                      <MySelect
                        type="select"
                        disabled={props.disabled}
                        style={props.disabled?disabledStyling:{}}
                        required={!props.disabled && ((props.upd.property.propertyType==='SF' && building.structureType==="DWELLING") || props.upd.property.propertyType==='CONDO')}
                        value={building.yearBuiltEstimate}
                        onChange={(v)=>updateBuildingDetail(index, 'yearBuiltEstimate', v)}
                        options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                      />
                    </Col>
                  </Row>
                  <br/>
                  {(props.upd.property.propertyType==='SF' && building.structureType==='DWELLING' )|| props.upd.property.propertyType==='CONDO'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}Select the best option to describe whether the structure is detached or how it is attached. {generateTooltip('attachmentType'+index, 'User to select the best option to identify whether the structure is attached to another structure. As the user faces the property, the attachment type for a \'Semi-Detached\' property should reflect the side that is not attached (e.g., a structure is \'Left Semi-Detached\' if the user faces an end unit that does not have a unit to the left). ')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={building.attachmentType}
                      onChange={(v)=>updateBuildingDetail(index, 'attachmentType', v)}
                      options={attachmentTypeEnum}
                    />
                    <br/>
                  </div>:null}

                  {building.buildingDesign==='DETACHED' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || props.upd.property.propertyType==='SF'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}What is the foundation for the structure?{generateTooltip('foundationType'+index, 'User to indicate the type(s) of foundation for the structure.')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={building.foundationType}
                      onChange={(v)=>updateBuildingFoundation(index, v)}
                      options={foundationTypeEnum}
                    />
                    <br/>
                    {
                      building.foundationType && building.foundationType!==''?building.foundationType.map(
                        (type, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeBuildingFoundation(index, index2)}/> {getFoundationTypeLabel(type)}
                          </span>
                        }
                      ):null
                    }
                  </div>:null}
                  <Row>
                    <Col sm="6">
                      <label>{!props.disabled?<font color="red">*</font>:null}What is the construction status that best describes the subject property? {generateTooltip('constructionStatus'+index, 'User to select the option that best describes the structure\'s construction status.')}</label>
                      <MySelect
                        type="select"
                        required={!props.disabled}
                        disabled={props.disabled}
                        style={props.disabled?disabledStyling:{}}
                        value={building.constructionStatus}
                        onChange={(v)=>updateBuildingDetail(index, 'constructionStatus', v)}
                        options={constructionStatusEnum}
                      />
                    </Col>
                    {constructionType}
                  </Row>

                  <br/>
                  <div className="my-divider"/>
                  <label>View front and rear</label>
                  <div className="red-color" style={{fontSize:'13px'}}>
                    <i className="fa fa-check green-color"/> Show what is located to the front and behind of the property <br/>
                    <i className="fa fa-check green-color"/> Capture street (front) and surroundings (rear) <br/>
                    <i className="fa fa-times red-color"/> Do NOT take photos of the house itself  <br/>
                  </div>
                  <br/>
                  <div style={{ width: "400px", overflow: "hidden" }}>
                    <img
                      src="https://homevms-public-resources.s3.us-west-1.amazonaws.com/pdr_view_front_rear.png"
                      style={{
                        width: "408px",
                        margin: "-4px"
                      }}
                    />
                  </div>
                  
                  <Row>
                    <Col sm="6">
                      <label>{!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER'))?<font color="red">*</font>:null}Image(s) captured from the front of the structure showing the front yard, landscaping, and surroundings.</label>
                      <br/>
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0, width:0 }}
                        value={building.imageDwellingFront && building.imageDwellingFront.length>0?" ":""}
                        required={!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER'))}
                      />
                      <div>
                        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageDwellingFront', 'VIEW_FRONT', 0)}} className="my-dropzone">
                        {
                          ({getRootProps, getInputProps}) => (
                            <div
                              {...getRootProps({
                                className: 'my-dropzone',
                              })}
                            >
                              <input {...getInputProps()} />
                              <center>Choose files to upload</center>
                            </div>
                          )
                        }
                        </Dropzone>
                        {
                          !building.imageDwellingFront?null:building.imageDwellingFront.map(
                            (photo, index2)=>{
                              return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                <div>
                                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageDwellingFront',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                </div>
                                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                <div style={{marginTop:'5px'}}/>
                                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageDwellingFront', e.target.value)}/>
                                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                              </div>
                            }
                          )
                        }
                      </div>
                    </Col>
                    <Col sm="6">
                      <label>{!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER'))?<font color="red">*</font>:null}Image(s) captured from the back of the structure showing the backyard, landscaping, and surroundings.</label>
                      <br/>
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0, width:0 }}
                        value={building.imageDwellingRear&&building.imageDwellingRear.length>0?" ":""}
                        required={!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER'))}
                      />
                      <div>
                        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageDwellingRear', 'VIEW_REAR', 0)}} className="my-dropzone">
                        {
                          ({getRootProps, getInputProps}) => (
                            <div
                              {...getRootProps({
                                className: 'my-dropzone',
                              })}
                            >
                              <input {...getInputProps()} />
                              <center>Choose files to upload</center>
                            </div>
                          )
                        }
                        </Dropzone>
                        {
                          !building.imageDwellingRear?null:building.imageDwellingRear.map(
                            (photo, index2)=>{
                              return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                <div>
                                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageDwellingRear',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                </div>
                                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                <div style={{marginTop:'5px'}}/>
                                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageDwellingRear', e.target.value)}/>
                                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                              </div>
                            }
                          )
                        }
                      </div>
                    </Col>
                  </Row>

                  <label>View left and right</label>
                  <div className="red-color" style={{fontSize:'13px'}}>
                    <i className="fa fa-check green-color"/> Show what is located to the left and right of the property <br/>
                    <i className="fa fa-check green-color"/> Capture surrounding properties or environment <br/>
                    <i className="fa fa-times red-color"/> Do NOT take photos of the house itself  <br/>
                  </div>
                  <br/>
                  <div style={{ width: "400px", overflow: "hidden" }}>
                    <img
                      src="https://homevms-public-resources.s3.us-west-1.amazonaws.com/pdr_view_left_right.png"
                      style={{
                        width: "408px",
                        margin: "-4px"
                      }}
                    />
                  </div>
                  
                  <Row>
                    <Col sm="6">
                      <label>{!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='LEFT_SEMI_DETACHED'))?<font color="red">*</font>:null}Image(s) captured from the left side of the structure showing the side yard, landscaping, and surroundings. Left as facing the subject property from the street.</label>
                      <br/>
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0, width:0 }}
                        value={building.imageDwellingLeft&&building.imageDwellingLeft.length>0?" ":""}
                        required={!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='LEFT_SEMI_DETACHED'))}
                      />
                      <div>
                        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageDwellingLeft', 'VIEW_LEFT_SIDE', 0)}} className="my-dropzone">
                        {
                          ({getRootProps, getInputProps}) => (
                            <div
                              {...getRootProps({
                                className: 'my-dropzone',
                              })}
                            >
                              <input {...getInputProps()} />
                              <center>Choose files to upload</center>
                            </div>
                          )
                        }
                        </Dropzone>
                        {
                          !building.imageDwellingLeft?null:building.imageDwellingLeft.map(
                            (photo, index2)=>{
                              return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                <div>
                                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageDwellingLeft',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                </div>
                                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                <div style={{marginTop:'5px'}}/>
                                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageDwellingLeft', e.target.value)}/>
                                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                              </div>
                            }
                          )
                        }
                      </div>
                    </Col>
                    <Col sm="6">
                      <label>{!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='RIGHT_SEMI_DETACHED'))?<font color="red">*</font>:null}Image(s) captured from the right side of the structure showing the side yard, landscaping, and surroundings. Right as facing the subject property from the street.</label>
                      <br/>
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0, width:0 }}
                        value={building.imageDwellingRight&&building.imageDwellingRight.length>0?" ":""}
                        required={!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='RIGHT_SEMI_DETACHED'))}
                      />
                      <div>
                        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageDwellingRight', 'VIEW_RIGHT_SIDE', 0)}} className="my-dropzone">
                        {
                          ({getRootProps, getInputProps}) => (
                            <div
                              {...getRootProps({
                                className: 'my-dropzone',
                              })}
                            >
                              <input {...getInputProps()} />
                              <center>Choose files to upload</center>
                            </div>
                          )
                        }
                        </Dropzone>
                        {
                          !building.imageDwellingRight?null:building.imageDwellingRight.map(
                            (photo, index2)=>{
                              return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                <div>
                                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageDwellingRight',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                </div>
                                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                <div style={{marginTop:'5px'}}/>
                                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageDwellingRight', e.target.value)}/>
                                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                              </div>
                            }
                          )
                        }
                      </div>
                    </Col>
                  </Row>
                  <br/>
                  {
                    props.upd.property.propertyType==='SF'?<div>
                      <Row>
                        <Col sm="6">
                          <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of the front of the structure.</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={building.imageStructureFront&&building.imageStructureFront.length>0?" ":""}
                            required={!props.disabled}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageStructureFront', 'STRUCTURE_FRONT', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !building.imageStructureFront?null:building.imageStructureFront.map(
                                (photo, index2)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStructureFront',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageStructureFront', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </Col>
                        <Col sm="6">
                          <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of the back of the structure.</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={building.imageStructureRear&&building.imageStructureRear.length>0?" ":""}
                            required={!props.disabled}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageStructureRear', 'STRUCTURE_REAR', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !building.imageStructureRear?null:building.imageStructureRear.map(
                                (photo, index2)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStructureRear',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageStructureRear', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6">
                          <label>{!props.disabled && ( building.attachmentType==='LEFT_SEMI_DETACHED' || building.attachmentType==='DETACHED')?<font color="red">*</font>:null}Image(s) of the left side of the structure. Left as facing the subject property from the street.</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={building.imageStructureLeft&&building.imageStructureLeft.length>0?" ":""}
                            required={!props.disabled && ( building.attachmentType==='LEFT_SEMI_DETACHED' || building.attachmentType==='DETACHED')}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageStructureLeft', 'STRUCTURE_LEFT_SIDE', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !building.imageStructureLeft?null:building.imageStructureLeft.map(
                                (photo, index2)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStructureLeft',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageStructureLeft', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </Col>
                        <Col sm="6">
                          <label>{!props.disabled && ( building.attachmentType==='RIGHT_SEMI_DETACHED' || building.attachmentType==='DETACHED')?<font color="red">*</font>:null}Image(s) of the right side of the structure. Right as facing the subject property from the street.</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={building.imageStructureRight&&building.imageStructureRight.length>0?" ":""}
                            required={!props.disabled && ( building.attachmentType==='RIGHT_SEMI_DETACHED' || building.attachmentType==='DETACHED')}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageStructureRight', 'STRUCTURE_RIGHT_SIDE', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !building.imageStructureRight?null:building.imageStructureRight.map(
                                (photo, index2)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStructureRight',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageStructureRight', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </Col>
                      </Row>
                    </div>:null
                  }
                  <div className="my-divider"/>
                  {props.upd.property.propertyType==='CONDO'?<div>
                    <Row>
                      <Col sm="6">
                        <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of the front of the building.</label>
                        <br/>
                        <input
                          tabIndex={-1}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0, width:0 }}
                          value={building.imageBuildingFront&&building.imageBuildingFront.length>0?" ":""}
                          required={!props.disabled}
                        />
                        <div>
                          <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageBuildingFront', 'BUILDING_FRONT', 0)}} className="my-dropzone">
                          {
                            ({getRootProps, getInputProps}) => (
                              <div
                                {...getRootProps({
                                  className: 'my-dropzone',
                                })}
                              >
                                <input {...getInputProps()} />
                                <center>Choose files to upload</center>
                              </div>
                            )
                          }
                          </Dropzone>
                          {
                            !building.imageBuildingFront?null:building.imageBuildingFront.map(
                              (photo, index2)=>{
                                return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                  <div>
                                    <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageBuildingFront',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                  </div>
                                  <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                  <div style={{marginTop:'5px'}}/>
                                  {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageBuildingFront', e.target.value)}/>
                                  <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                </div>
                              }
                            )
                          }
                        </div>
                      </Col>
                      <Col sm="6">
                        <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of the back of the building.</label>
                        <br/>
                        <input
                          tabIndex={-1}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0, width:0 }}
                          value={building.imageBuildingRear&&building.imageBuildingRear.length>0?" ":""}
                          required={!props.disabled }
                        />
                        <div>
                          <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageBuildingRear', 'BUILDING_REAR', 0)}} className="my-dropzone">
                          {
                            ({getRootProps, getInputProps}) => (
                              <div
                                {...getRootProps({
                                  className: 'my-dropzone',
                                })}
                              >
                                <input {...getInputProps()} />
                                <center>Choose files to upload</center>
                              </div>
                            )
                          }
                          </Dropzone>
                          {
                            !building.imageBuildingRear?null:building.imageBuildingRear.map(
                              (photo, index2)=>{
                                return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                  <div>
                                    <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageBuildingRear',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                  </div>
                                  <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                  <div style={{marginTop:'5px'}}/>
                                  {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageBuildingRear', e.target.value)}/>
                                  <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                </div>
                              }
                            )
                          }
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <label>{!props.disabled && ((building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' ||building.buildingDesign==='DETACHED' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='LEFT_SEMI_DETACHED'))?<font color="red">*</font>:null}Image(s) of the left side of the building</label>
                        <br/>
                        <input
                          tabIndex={-1}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0, width:0 }}
                          value={building.imageBuildingLeft&&building.imageBuildingLeft.length>0?" ":""}
                          required={!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='LEFT_SEMI_DETACHED'))}
                        />
                        <div>
                          <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageBuildingLeft', 'BUILDING_LEFT', 0)}} className="my-dropzone">
                          {
                            ({getRootProps, getInputProps}) => (
                              <div
                                {...getRootProps({
                                  className: 'my-dropzone',
                                })}
                              >
                                <input {...getInputProps()} />
                                <center>Choose files to upload</center>
                              </div>
                            )
                          }
                          </Dropzone>
                          {
                            !building.imageBuildingLeft?null:building.imageBuildingLeft.map(
                              (photo, index2)=>{
                                return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                  <div>
                                    <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageBuildingLeft',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                  </div>
                                  <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                  <div style={{marginTop:'5px'}}/>
                                  {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageBuildingLeft', e.target.value)}/>
                                  <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                </div>
                              }
                            )
                          }
                        </div>
                      </Col>
                      <Col sm="6">
                        <label>{!props.disabled && ((building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' ||building.buildingDesign==='DETACHED' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='RIGHT_SEMI_DETACHED'))?<font color="red">*</font>:null}Image(s) of the right side of the building.</label>
                        <br/>
                        <input
                          tabIndex={-1}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0, width:0 }}
                          value={building.imageBuildingRight&&building.imageBuildingRight.length>0?" ":""}
                          required={!props.disabled && ((building.structureType==='DWELLING' || building.buildingDesign==='GARDEN' || building.buildingDesign==='LOW_RISE' || building.buildingDesign==='MID_RISE' || building.buildingDesign==='HIGH_RISE' || building.buildingDesign==='ROWHOUSE_TOWNHOUSE' || building.buildingDesign==='OTHER') && (building.attachmentType==='DETACHED' || building.attachmentType==='RIGHT_SEMI_DETACHED'))}
                        />
                        <div>
                          <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageBuildingRight', 'BUILDING_RIGHT', 0)}} className="my-dropzone">
                          {
                            ({getRootProps, getInputProps}) => (
                              <div
                                {...getRootProps({
                                  className: 'my-dropzone',
                                })}
                              >
                                <input {...getInputProps()} />
                                <center>Choose files to upload</center>
                              </div>
                            )
                          }
                          </Dropzone>
                          {
                            !building.imageBuildingRight?null:building.imageBuildingRight.map(
                              (photo, index2)=>{
                                return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                  <div>
                                    <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageBuildingRight',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                  </div>
                                  <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                  <div style={{marginTop:'5px'}}/>
                                  {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageBuildingRight', e.target.value)}/>
                                  <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                </div>
                              }
                            )
                          }
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <label>{!props.disabled?<font color="red">*</font>:null}Number of stories of the building the subject unit is in.</label>
                        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={building.numberOfStories} onChange={(e)=>updateBuildingDetail(index,'numberOfStories', e.target.value)}/>
                      </Col>
                      <Col sm="6">
                        <label>{!props.disabled?<font color="red">*</font>:null}Number of elevators in the building the unit is in.</label>
                        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={building.numberOfElevators} onChange={(e)=>updateBuildingDetail(index,'numberOfElevators', e.target.value)}/>
                      </Col>
                    </Row>
                    <br/>
                    {offstreetParking}
                    <CondoCarStorages {...props} index={index}/>
                  </div>:null}

                  <ExteriorDeficiencies {...props} index={index}/>
                  <ExteriorUpdates {...props} index={index}/>
                  <Units {...props} index={index}/>
                </CardBody>
              </Card>
            </div>)
          }
        )
      }
    </div>
  );
}

export default Building;